/**
 * Endpoint clients del maestro de clientes:
 *   - `/api/clientes/:id`                → ficha completa.
 *   - `/api/clientes/listar?id=&nombre=` → filtro del maestro.
 */

import {
  ClienteBuscarResponse,
  ClienteListarResponse,
  type ClienteBuscar,
  type ClienteListar,
} from '@/api/contracts/cliente-acsis';
import { apiFetch } from '@/api/http';

export async function buscarClientePorId(id: string): Promise<ClienteBuscar> {
  const data = await apiFetch<unknown>(
    `/clientes/${encodeURIComponent(id)}`,
    { auth: true },
  );
  return ClienteBuscarResponse.parse(data);
}

/**
 * Filtra el maestro de clientes. Los dos criterios se combinan con AND en el
 * back; mandamos solo los que tienen contenido.
 */
export async function listarClientes(params: {
  id?: string;
  nombre?: string;
}): Promise<ClienteListar> {
  const qs = new URLSearchParams();
  if (params.id?.trim()) qs.set('id', params.id.trim());
  if (params.nombre?.trim()) qs.set('nombre', params.nombre.trim());
  const data = await apiFetch<unknown>(`/clientes/listar?${qs.toString()}`, {
    auth: true,
  });
  return ClienteListarResponse.parse(data);
}
